import type { Pet } from "../data/pets";

export interface PetManifest {
  id: string;
  displayName: string;
  description: string;
  spritesheetPath: "spritesheet.webp";
  spriteVersionNumber: 2;
  kind: "animal" | "person";
}

export interface PetValidationReport {
  manifestId: string;
  atlasSize: "1536x2288";
  cellSize: "192x208";
  statesDetected: 11;
  spriteVersionNumber: 2;
}

export function petVersionNumber(_pet: Pet): 2 {
  return 2;
}

export function petRowCount(_pet: Pet): 11 {
  return 11;
}

export function petAtlasSize(_pet: Pet): "1536x2288" {
  return "1536x2288";
}

export function createPetManifest(pet: Pet): PetManifest {
  return {
    id: pet.id,
    displayName: pet.name,
    description: pet.description,
    spritesheetPath: "spritesheet.webp",
    spriteVersionNumber: petVersionNumber(pet),
    kind: pet.species === "bot" ? "person" : "animal",
  };
}

export function createValidationReport(pet: Pet): PetValidationReport {
  return {
    manifestId: pet.id,
    atlasSize: petAtlasSize(pet),
    cellSize: "192x208",
    statesDetected: petRowCount(pet),
    spriteVersionNumber: petVersionNumber(pet),
  };
}

export function petDownloadPath(pet: Pet): string {
  return `/api/pets/${pet.id}/download`;
}

export function petShareData(pet: Pet) {
  return {
    id: pet.id,
    displayName: pet.name,
    description: pet.description,
    spritesheetPath: "spritesheet.webp",
    spriteVersionNumber: petVersionNumber(pet),
    kind: pet.species === "bot" ? "person" : "animal",
    ownerHandle: pet.creatorHandle,
    ownerName: pet.creator,
    uploadedAt: `${pet.createdAt}T00:00:00.000Z`,
    viewCount: pet.views,
    downloadCount: pet.downloads,
    likeCount: pet.likes,
    tags: pet.tags,
    spritesheetUrl: `/api/pets/${pet.id}/spritesheet`,
    posterUrl: `/pet-assets/${pet.id}/preview.webp`,
    downloadUrl: petDownloadPath(pet),
    validationReport: createValidationReport(pet),
  };
}
